/** Tiny classnames joiner — avoids a runtime dependency on clsx. */
export function cx(
  ...parts: Array<string | false | null | undefined>
): string {
  return parts.filter(Boolean).join(" ");
}
